<!-- 404 -->
<template>
  <div class="crpg-t-error-404">
    <ComponentsOrganismsErrorDefault />
  </div>
</template>

<script>
import ComponentsOrganismsErrorDefault from "@/components/organisms/error/Default.vue";

export default {
  name: "TemplatesError404",
  components: {
    ComponentsOrganismsErrorDefault,
  },
};
</script>

<style lang="scss" scoped></style>
